// src/components/BookingModal/hooks/useBookingPricing.js

const useBookingPricing = (
  selectedRoom,
  searchDetails
) => {

  const roomPrice = Number(
    selectedRoom?.todayPrice ||
    selectedRoom?.price ||
    selectedRoom?.basePrice ||
    0
  );

  const getDateOnly = (value) => {

    if (!value) return null;

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return null;
    }

    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
  };

  const checkInDate = getDateOnly(
    searchDetails?.checkIn
  );

  const checkOutDate = getDateOnly(
    searchDetails?.checkOut
  );

  const calculatedNights =
    checkInDate &&
    checkOutDate
      ? Math.max(
          Math.round(
            (checkOutDate - checkInDate) /
              (1000 * 60 * 60 * 24)
          ),
          0
        )
      : 0;

  const roomTotal =
    roomPrice * calculatedNights;

  const taxRate = 18;

  const taxAmount =
    roomTotal * (taxRate / 100);

  const finalTotal =
    roomTotal + taxAmount;

  return {
    roomPrice,
    calculatedNights,
    roomTotal,
    taxRate,
    taxAmount,
    finalTotal,
  };
};

export default useBookingPricing;